/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { isContainerNode } from "utils/AccessibilityUtils";

const sanitizeRect = ({ xMin, yMin, xMax, yMax }) => ({
  xMin: Math.min(xMin, xMax),
  xMax: Math.max(xMin, xMax),
  yMin: Math.min(yMin, yMax),
  yMax: Math.max(yMin, yMax)
});

class AccessibilityNode {
  constructor(
    {
      contentDesc,
      contentRole,
      contentRect,
      annotInfo,
      headingInfo,
      fieldInfo,
      imageInfo,
      linkInfo,
      textAttributeNodes
    },
    id
  ) {
    this.id = id;
    this.contentDesc = contentDesc;
    this.contentRole = contentRole;
    this.contentRect = contentRect && sanitizeRect(contentRect);
    this.info = annotInfo || headingInfo || fieldInfo || imageInfo || linkInfo;
    this.textAttributeNodes = textAttributeNodes;
  }
}

class ContainerAccessibilityNode extends AccessibilityNode {
  constructor(node, id) {
    super(node, id);
    this.children = node.children.map((item, index) =>
      isContainerNode(item)
        ? new ContainerAccessibilityNode(item, `${id}-${index}`)
        : new AccessibilityNode(item, `${id}-${index}`)
    );
  }
}

export { AccessibilityNode, ContainerAccessibilityNode };
